import { useFetch } from '@chipinside/fetcher'
import React from 'react'

import { useAnimal } from '#/store/ducks/context'
import { useFarmSlug } from '#/store/ducks/farm/index'
import { endpoint } from '#/store/services/endpoints'

import { DatasheetContent } from './content'

function AnimalDatasheet() {
  const animal = useAnimal()
  const farmSlug = useFarmSlug()

  const controller = endpoint.farm.animal.status({
    farm: farmSlug,
    animal: animal?.slug,
  })

  const { data, isLoading } = useFetch({ controller })
  const AnimalData = data

  return <DatasheetContent AnimalData={AnimalData} loading={isLoading} />
}

export default AnimalDatasheet
